<template>
  <MasterLayout>
    <div class="new-staff">
      <div class="add_new_bank_account_header">
        <p> {{ $t('text.cUser.createUser.title1') }}</p>
      </div>
      <div class="cover">
        <div class="personal">
          <div class="row">
            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel">
                  {{ $t("text.editStaff.email") }}
                </span>
              </label>
              <div class="input__block">
                <input
                  type="text"
                  :placeholder="this.$t('text.editStaff.email')"
                  v-model="email"
                  class="form-control"
                />
              </div>
            </div>

            <div class="input__group__block mt-4 col-md-6">
              <label class="required">
                <span class="mylabel"> {{ $t('text.cUser.addUserToRole.selectRole') }} </span>
              </label>
              <div class="input__block">
                <select v-model="role">
                  <option value="selectRole" disabled> {{ $t('text.cUser.addUserToRole.selectRole') }} </option>
                  <option value="CompanyAdmin"> {{ $t('text.cUser.addUserToRole.companyAdmin') }} </option>
                  <option value="Branch Manager"> {{ $t('text.cUser.addUserToRole.branchManager') }} </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row justify-content-start">
            <div
              class="input__group__block mt-4 col-md-6"
              :style="[
                role == 'Branch Manager'
                  ? { visibility: 'visible' }
                  : { visibility: 'hidden' },
              ]"
            >
              <label class="required">
                <span class="mylabel"> {{ $t('text.cUser.addUserToRole.station') }}  </span>
              </label>
              <div class="input__block">
                <select v-model="branch">
                  <option value="selectBranch" disabled>{{ $t('text.cUser.addUserToRole.selectStation') }} </option>
                  <option
                    v-for="(branch, i) in branches"
                    :key="i"
                    :value="branch.id"
                  >
                    {{ branch.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-6"></div>
          </div>
        </div>

        <div class="text-center mt-4 pb-4">
          <button
            class="save__btn"
            @click="createUser($event)"
            :disabled="isButtonDisabled ? true : null"
            :style="[
              isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' },
            ]"
          >
            Add User  {{ $t('text.cUser.createUser.title1') }} <span></span>
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import backgroundUrl from "@/assets/img/retain.jpg";

import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "AddStaff",
  components: {
    MasterLayout,
  },
  data() {
    return {
      email: null,
      isButtonDisabled: false,
      showLoader: true,
      backgroundUrl,
      role: "selectRole",
      branches: [],
      branch: "selectBranch",
      company: null,
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
    });
    if(this.$route.query.companyId){
      this.getBranches();
    }
    document.title = "Add User To Role:: Epump Company";
  },
  watch: {
    company(company) {
      if (company !== null) {
        this.getBranches();
      }
    },
  },
  mounted() {

  },
  beforeDestroy() {},
  methods: {
    validEmail(email) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
        return true;
      }
      return false;
    },

    getBranches() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/Branches/${this.$route.query.companyId ? this.$route.query.companyId :  this.company.id}`,
          configObject.authConfig()
        )
        .then((res) => {
          res.data.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase()
              ? 1
              : b.name.toLowerCase() > a.name.toLowerCase()
              ? -1
              : 0;
          });
          this.branches = res.data;
        })
        .catch((error) => {});
    },

    createUser($event) {
      $event.preventDefault();
      if (!this.email) {
        this.$toast.open({
          message: this.$t("text.errors.emailMissing"),
          type: "error",
          duration: 3000,
        });
        return;
      }
      if (!this.validEmail(this.email)) {
        this.$toast.open({
          message: this.$t("text.errors.invalidEmail"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (this.role == "selectRole") {
        this.$toast.open({
          message:  this.$t("text.cUsers.addUserToRole.roleError"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      if (this.role == "Branch Manager" && this.branch == "selectBranch") {
        this.$toast.open({
          message:  this.$t("text.cUsers.addUserToRole.stationError"),
          type: "error",
          duration: 3000,
        });
        return;
      }

      let data = {
        email: this.email,
        branchId: this.role == "CompanyAdmin" ? null : this.branch,
        role: this.role,
      };

      //   return

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Company/AddUserToRole/${this.$route.query.companyId ? this.$route.query.companyId : this.company.id}`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.$router.push({ name: "company_users" });
          this.$toast.open({
            message:  this.$t("text.cUsers.addUserToRole.mapSuccess"),
            type: "success",
            duration: 5000,
          });
          $(".loader").hide();
          this.isButtonDisabled = false;
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
  },
};
</script>
